<dynamic-form
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [areaName]="areaName"
  [model]="model"
  [columns]="columns"
  [erroremessage]="erroremessage"
  (valueChange)="onDynamicFormChanges($event)"
  (CompleteData)="CompleteData($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()"
  [noSubmit]="deactivateSave"
  class="zone-price-announcement">
  <ng-container class="content">
    <editable-grid class="zone-price" *ngIf="Zones?.length > 0"
    [DefaultValues]="DefaultValues"
    [columns]="Zones"
    [dataList]="model.Zones"
    [isAdd]="false"
    [isDelete]="false">
  </editable-grid>
  </ng-container>
</dynamic-form>
